<template>
    <form-dialog ref="form-saveas" title="另存为模板" :data="data" width="80%" :visible.sync="visibleSync" :columns="columnList" @confirm="SaveAs"></form-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `SuppliesTemplateSaveAs`,
    props: {
        visible: { type: Boolean, default: () => false },
        applytype: { type: Number },
        data: { type: Object }
    },
    data() {
        return {
            title: `耗材模板另存为`
        }
    },
    created() {
        // this.$store.dispatch("ADD_WARD_AUTH")
    },
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`, `active_ward`]),
        visibleSync: {
            get: function() {
                return this.visible
            },
            set: function(newval) {
                this.$emit(`update:visible`, newval)
            }
        },
        columnList() {
            let me = this
            return [{
                type: `string`,
                prop: `name`,
                label: `名称`,
                colspan: 6,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `radio`,
                prop: `template_type`,
                label: `模板类型`,
                width: `180`,
                colspan: 6,
                options: this.applytype == 1 ? [{ value: 1, label: `麻醉` }]
                    : (this.applytype == 2 ? [{ value: 2, label: `护理` }] : [
                        { value: 1, label: `麻醉` },
                        { value: 2, label: `护理` }
                    ]),
                default: this.applytype || 1
            }, {
                type: `radio`,
                prop: `region_type`,
                label: `可用范围`,
                width: `180`,
                colspan: 6,
                options: `enum_region_type`,
                default: 1,
                change: (that, { row }) => {
                    if (row.region_type == 2) {
                        if (!row.dic_ward_ids) {
                            var ids = []
                            ids.push(this.active_ward.value)
                            row.dic_ward_ids = ids
                        }
                    }
                }
            }, {
                type: `groupmultiselect`,
                prop: `dic_ward_ids`,
                label: `可用区域`,
                // width: "180",
                isListable: true,
                isEditable: true,
                isCreatable: true,
                colspan: 6,
                options: this.ward_auth,
                readonly: function(that, { row, column, area }) {
                    if (area == `form`) {
                        return row.region_type === 1
                    } else {
                        return true
                    }
                }
            }, {
                type: `table`,
                prop: `supplies`,
                label: `耗材`,
                isEditable: true,
                isCreatable: true,
                options: [{
                    type: `string`,
                    prop: `id`,
                    label: `排序`,
                    isKey: true
                }, {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    isListable: true,
                    readonly: false,
                    default: 1
                }, {
                    type: `remoteselect`,
                    prop: `dic_supplies`,
                    label: `名称`,
                    width: `400`,
                    isListable: true,
                    readonly: false,
                    options: `/api/AcisSystem/Supplies/SearchSpec?applytype=${me.applytype || 0}`
                }, {
                    type: `number`,
                    prop: `quantity`,
                    label: `数量`,
                    isListable: true,
                    readonly: false,
                    default: 1
                }],
                colspan: 24,
                default: []
            }]
        }
    },
    methods: {
        saveOne(row) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.post(`/api/AcisSystem/SuppliesTemplate/Post`, {
                    'name': row.name,
                    'template_type': row.template_type,
                    'items': row.supplies.map(s => {
                        return {
                            'dic_supplies_id': s.dic_supplies.value || s.dic_supplies_id,
                            'quantity': s.quantity,
                            'display_order': s.display_order
                        }
                    }),
                    'regions': row.region_type == 1 ? [{ 'owner': this.currentUser.username }] : row.dic_ward_ids.map(d => {
                        return {
                            'dic_operating_ward_id': _.startsWith(d, `ow_`) ? d.substr(3) : 0,
                            'dic_recovery_ward_id': _.startsWith(d, `rw_`) ? d.substr(3) : 0
                        }
                    })
                })
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        SaveAs(row) {
            this.saveOne(row).then(data => {
                this.$emit(`save-success`)
                this.visibleSync = false
            })
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Supplies/SaveAs.vue